// extracted by mini-css-extract-plugin
export default {"container":"FieldLabel_container__BMiWV","required":"FieldLabel_required__ZArkP"};